module.exports = __webpack_public_path__ + "static/media/noImage.32e55f10.png";